import React, { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import LinkPanelWrapper from './LinkPanelWrapper.js';
import AnchorPanel from '../AnchorComponents/AnchorPanel.js';
import { mergeStyles } from 'wix-rich-content-common';
import { FocusManager, RadioGroup, ModalCloseButton, SettingsMobileHeader } from 'wix-rich-content-ui-components';
import { s as styleInject } from '../../style-inject.es-746bb8ed.js';
import LinkActionsButtons from './LinkActionsButtons.js';
import { RADIO_GROUP_VALUES } from '../AnchorComponents/consts.js';
import './LinkPanel.js';
import 'wix-rich-content-common/libs/Tooltip';
import './AdvancedCheckboxes.js';
import './consts.js';
import '../../link-panel-d6b164a2.js';
import './LinkPanelDropdown.js';
import 'lodash';
import '../../anchor-panel-502e4ab1.js';
import '../AnchorComponents/anchorUtils.js';
import '../AnchorComponents/FilterDropdownElement.js';
import '../AnchorComponents/AnchorableElement.js';
import 'wix-rich-content-editor-common';
import 'wix-rich-content-common/libs/imageUtils';
import '../AnchorComponents/FilterDropdown.js';
import '../Icons/AnchorsThumbnails/ParagraphIcon.js';
import '../Icons/AnchorsThumbnails/H1Icon.js';
import '../Icons/AnchorsThumbnails/H2Icon.js';
import '../Icons/AnchorsThumbnails/H3Icon.js';
import '../Icons/AnchorsThumbnails/H4Icon.js';
import '../Icons/AnchorsThumbnails/H5Icon.js';
import '../Icons/AnchorsThumbnails/H6Icon.js';
import '../Icons/AnchorsThumbnails/CodeBlockIcon.js';
import '../Icons/AnchorsThumbnails/BlockQuoteIcon.js';
import '../Icons/AnchorsThumbnails/ImageIcon.js';
import '../Icons/AnchorsThumbnails/GalleryIcon.js';
import '../Icons/AnchorsThumbnails/VideoIcon.js';
import '../Icons/AnchorsThumbnails/MapIcon.js';
import '../Icons/AnchorsThumbnails/ButtonIcon.js';
import '../Icons/AnchorsThumbnails/GiphyIcon.js';
import '../Icons/AnchorsThumbnails/FileIcon.js';

var css_248z = ".glob_fontElementMap,.xWFSk{font-family:var(--ricos-font-family,unset)}.ScCbe{color:var(--ricos-settings-text-color,#000);font-family:var(--ricos-settings-text-font-family,HelveticaNeue,Helvetica,Arial);font-size:14px;font-stretch:normal;font-style:normal;font-weight:300;height:100%;min-width:360px;position:relative;width:502px}[dir] .ScCbe{padding:20px}.rKo5v{display:flex;flex-direction:column-reverse;font-family:var(--ricos-settings-text-font-family,HelveticaNeue,Helvetica,Arial);font-size:14px;font-stretch:normal;font-style:normal;font-weight:300;height:100vh;justify-content:flex-end}._9EuIp{display:flex;height:279px}._0BWrv{display:flex;height:calc(100% - 217px)}[dir] ._0BWrv{padding:0 18px}.jmyfR{width:100%}[dir=ltr] .jmyfR{margin:14px 0 0 20px}[dir=rtl] .jmyfR{margin:14px 20px 0 0}._5q8sW{width:100%}[dir] ._5q8sW{margin:8px 0 0}[dir] .zV2Wz{border-bottom:1px solid var(--ricos-settings-dividers-color,rgba(51,51,51,.1));margin:0 -19px}[dir] .zV2Wz._7gCUy{margin:0}.LB-c7{height:auto}[dir=ltr] .LB-c7{border-right:1px solid var(--ricos-settings-dividers-color,rgba(51,51,51,.1));margin:0 0 0 20px}[dir=rtl] .LB-c7{border-left:1px solid var(--ricos-settings-dividers-color,rgba(51,51,51,.1));margin:0 20px 0 0}.fEGam{font-size:16px;line-height:1.5}[dir] .fEGam{margin-bottom:16px;margin-top:2px}.fEGam.NaNlH{display:flex;justify-content:space-between}.uMByf{display:flex;flex-direction:column;height:fit-content}[dir] .uMByf{margin-top:20px}.uMByf label{align-items:center;display:inline-flex;font-size:16px;line-height:1.5;width:max-content}[dir] .uMByf label{margin-bottom:14px}.uMByf span{vertical-align:text-bottom}.zDmHH{display:flex}[dir] .zDmHH{border-bottom:1px solid #dcdcdc;margin-bottom:12px}.zDmHH .Y4YbM{align-items:center;display:flex;height:46px;justify-content:center;width:100%}[dir] .zDmHH .Y4YbM{padding:8px 0}[dir] .zDmHH .Y4YbM:hover{cursor:pointer}.zDmHH .PIk9f{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}[dir] .zDmHH .PIk9f{border-bottom:2px solid var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}.T-d--{display:flex;flex-direction:column;gap:12px}";
var styles = {"fontElementMap":"xWFSk","multiSelectLinkPanel_container":"ScCbe","multiSelectLinkPanel_container_mobile":"rKo5v","multiSelectLinkPanel_content":"_9EuIp","multiSelectLinkPanel_content_mobile":"_0BWrv","multiSelectLinkPanel_LinkPanelContainer":"jmyfR","multiSelectLinkPanel_LinkPanelContainer_mobile":"_5q8sW","multiSelectLinkPanel_actionsDivider":"zV2Wz","multiSelectLinkPanel_actionsDivider_mobile":"_7gCUy","linkPanel_VerticalDivider":"LB-c7","multiSelectLinkPanel_header":"fEGam","multiSelectLinkPanel_header_withCloseButton":"NaNlH","multiSelectLinkPanel_radioButtons":"uMByf","multiSelectLinkPanel_tabsWrapper":"zDmHH","multiSelectLinkPanel_tab":"Y4YbM","multiSelectLinkPanel_tabSelected":"PIk9f","multiSelectLinkPanel_actionsWrapper_mobile":"T-d--"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class MultiSelectLinkPanel extends PureComponent {
  constructor(props) {
    super(props);
    __publicField(this, "renderRadioGroup", () => {
      const { radioGroupValue, changeRadioGroup, t } = this.props;
      return /* @__PURE__ */ React.createElement(
        RadioGroup,
        __spreadValues({
          className: styles.multiSelectLinkPanel_radioButtons,
          dataSource: [
            {
              value: RADIO_GROUP_VALUES.EXTERNAL_LINK,
              labelText: t("LinkTo_Modal_Sidebar_Website"),
              dataHook: "link-radio"
            },
            {
              value: RADIO_GROUP_VALUES.ANCHOR,
              labelText: t("LinkTo_Modal_Sidebar_Section"),
              dataHook: "anchor-radio"
            }
          ],
          value: radioGroupValue,
          onChange: changeRadioGroup
        }, this.props)
      );
    });
    __publicField(this, "renderSeparator", () => {
      const { isMobile } = this.props;
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames(styles.multiSelectLinkPanel_actionsDivider, {
            [styles.multiSelectLinkPanel_actionsDivider_mobile]: isMobile
          }),
          role: "separator"
        }
      );
    });
    __publicField(this, "renderDesktopHeader", () => {
      const {
        t,
        showCloseButton,
        buttonsProps: { onCancel }
      } = this.props;
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames(styles.multiSelectLinkPanel_header, {
            [styles.multiSelectLinkPanel_header_withCloseButton]: showCloseButton
          })
        },
        /* @__PURE__ */ React.createElement("div", null, t("LinkTo_Modal_Header")),
        showCloseButton && /* @__PURE__ */ React.createElement(ModalCloseButton, { closeModal: onCancel })
      ), this.renderSeparator());
    });
    __publicField(this, "renderMultiSelectActions", () => {
      const { isMobile, buttonsProps, t } = this.props;
      return /* @__PURE__ */ React.createElement("div", { className: isMobile ? styles.multiSelectLinkPanel_actionsWrapper_mobile : null }, isMobile ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(SettingsMobileHeader, __spreadProps(__spreadValues({}, buttonsProps), { title: t("MobileLinkModal_Title") })), this.renderMobileTabs()) : /* @__PURE__ */ React.createElement(LinkActionsButtons, __spreadValues({}, buttonsProps)));
    });
    __publicField(this, "renderMobileTabs", () => {
      const { t, radioGroupValue, changeRadioGroup } = this.props;
      return /* @__PURE__ */ React.createElement("div", { className: styles.multiSelectLinkPanel_tabsWrapper }, /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames(styles.multiSelectLinkPanel_tab, {
            [styles.multiSelectLinkPanel_tabSelected]: radioGroupValue === RADIO_GROUP_VALUES.EXTERNAL_LINK
          }),
          onClick: () => changeRadioGroup(RADIO_GROUP_VALUES.EXTERNAL_LINK),
          "data-hook": "linkPanelContainerLinkTab"
        },
        t("LinkTo_Modal_Sidebar_Website")
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames(styles.multiSelectLinkPanel_tab, {
            [styles.multiSelectLinkPanel_tabSelected]: radioGroupValue === RADIO_GROUP_VALUES.ANCHOR
          }),
          onClick: () => changeRadioGroup(RADIO_GROUP_VALUES.ANCHOR),
          "data-hook": "linkPanelContainerAnchorTab"
        },
        t("LinkTo_Modal_Sidebar_Section")
      ));
    });
    this.styles = mergeStyles({ styles, theme: props.theme });
  }
  render() {
    const { styles: styles2 } = this;
    const {
      isMobile,
      ariaProps,
      showNewTabCheckbox,
      showNoFollowCheckbox,
      showSponsoredCheckbox,
      showNoReferrerCheckbox,
      sharedPanelsProps,
      radioGroupValue,
      linkPanelValues,
      onChangeLinkPanel,
      onChangeAnchorPanel,
      anchorableBlocksData,
      anchorPanelValues,
      blockPreview,
      hasCheckboxes = true
    } = this.props;
    const containerClassName = !isMobile ? styles2.multiSelectLinkPanel_container : styles2.multiSelectLinkPanel_container_mobile;
    const contentClassName = !isMobile ? styles2.multiSelectLinkPanel_content : styles2.multiSelectLinkPanel_content_mobile;
    const linkPanelContainerClassName = !isMobile ? styles2.multiSelectLinkPanel_LinkPanelContainer : styles2.multiSelectLinkPanel_LinkPanelContainer_mobile;
    return /* @__PURE__ */ React.createElement(
      FocusManager,
      __spreadValues({
        className: containerClassName,
        "data-hook": "linkPanelContainer",
        role: "form"
      }, ariaProps),
      !isMobile && this.renderDesktopHeader(),
      /* @__PURE__ */ React.createElement("div", { className: contentClassName }, !isMobile && /* @__PURE__ */ React.createElement(React.Fragment, null, this.renderRadioGroup(), /* @__PURE__ */ React.createElement("div", { className: styles2.linkPanel_VerticalDivider })), radioGroupValue === RADIO_GROUP_VALUES.EXTERNAL_LINK && /* @__PURE__ */ React.createElement("div", { className: linkPanelContainerClassName }, /* @__PURE__ */ React.createElement(
        LinkPanelWrapper,
        __spreadValues({
          linkValues: linkPanelValues,
          onChange: onChangeLinkPanel,
          showNewTabCheckbox,
          showNoFollowCheckbox,
          showSponsoredCheckbox,
          showNoReferrerCheckbox,
          hasCheckboxes,
          isMobile
        }, sharedPanelsProps)
      )), radioGroupValue === RADIO_GROUP_VALUES.ANCHOR && /* @__PURE__ */ React.createElement(
        AnchorPanel,
        __spreadValues({
          anchorableBlocksData,
          anchorValues: anchorPanelValues,
          onChange: onChangeAnchorPanel,
          blockPreview
        }, sharedPanelsProps)
      )),
      !isMobile && this.renderSeparator(),
      this.renderMultiSelectActions()
    );
  }
}
MultiSelectLinkPanel.propTypes = {
  theme: PropTypes.object.isRequired,
  t: PropTypes.func,
  ariaProps: PropTypes.object,
  showNewTabCheckbox: PropTypes.bool,
  showNoFollowCheckbox: PropTypes.bool,
  showSponsoredCheckbox: PropTypes.bool,
  showNoReferrerCheckbox: PropTypes.bool,
  sharedPanelsProps: PropTypes.object,
  buttonsProps: PropTypes.object,
  radioGroupValue: PropTypes.string,
  changeRadioGroup: PropTypes.func,
  linkPanelValues: PropTypes.object,
  onChangeLinkPanel: PropTypes.func,
  onChangeAnchorPanel: PropTypes.func,
  anchorableBlocksData: PropTypes.object,
  anchorPanelValues: PropTypes.object,
  isMobile: PropTypes.bool,
  hasCheckboxes: PropTypes.bool,
  blockPreview: PropTypes.func,
  showCloseButton: PropTypes.bool
};

export { MultiSelectLinkPanel as default };
//# sourceMappingURL=MultiSelectLinkPanel.js.map
